import { render, staticRenderFns } from "./rate-change-record.vue?vue&type=template&id=0eda2842&"
import script from "./rate-change-record.vue?vue&type=script&lang=ts&"
export * from "./rate-change-record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports